/* Brindes surpresa Black 2026 — sincroniza o carrinho com a lista decidida em Liquid (snippets/brindes-black.liquid).
   Só age se data-enabled estiver presente (algum produto-brinde com ID configurado). */
(function () {
  if (customElements.get('brindes-black')) return;
  const SECTIONS = ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];
  class BrindesBlack extends HTMLElement {
    connectedCallback() { this.sync(); }
    parse(attr) { try { return JSON.parse(this.dataset[attr] || '{}'); } catch (e) { return {}; } }
    guard() {
      try {
        const now = Date.now();
        const hist = JSON.parse(sessionStorage.getItem('bb_sync') || '[]').filter((t) => now - t < 10000);
        if (hist.length >= 4) { console.warn('[brindes-black] loop guard'); return false; }
        hist.push(now); sessionStorage.setItem('bb_sync', JSON.stringify(hist));
      } catch (e) {}
      return true;
    }
    async sync() {
      if (!this.dataset.enabled) return;
      const desired = this.parse('desired'), present = this.parse('present'), updates = {};
      Object.entries(desired).forEach(([vid, q]) => { if ((present[vid] || 0) !== q) updates[vid] = q; });
      Object.keys(present).forEach((vid) => { if (!(vid in desired)) updates[vid] = 0; });
      if (!Object.keys(updates).length || !this.guard()) return;
      try {
        window.__bbSyncing = true;
        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates, sections: SECTIONS.join(',') })
        });
        if (!res.ok) { console.warn('[brindes-black] update falhou', res.status); return; }
        const data = await res.json();
        if (window.location.pathname.replace(/\/$/, '') === '/cart') { window.location.reload(); return; }
        SECTIONS.forEach((id) => {
          const el = document.getElementById(id);
          const html = data.sections && data.sections[id];
          if (!el || !html) return;
          const inner = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
          if (inner) el.innerHTML = inner.innerHTML;
        });
        document.dispatchEvent(new CustomEvent('brindes-black:synced', { detail: updates }));
      } catch (e) { console.warn('[brindes-black]', e); }
      finally { window.__bbSyncing = false; }
    }
  }
  customElements.define('brindes-black', BrindesBlack);

  /* 02/11: na página /cart o tema altera o carrinho (remover item, mudar quantidade) sem refazer o rodapé,
     então o brinde ficava da faixa antiga (ex.: tira o Kit Diamante e o Escultor continua). Depois de qualquer
     /cart/change|update|add que não seja o nosso, buscamos o rodapé de novo: o <brindes-black> novo monta e sincroniza. */
  if (window.location.pathname.replace(/\/$/, '') === '/cart' && !window.__bbFetchHook) {
    window.__bbFetchHook = true;
    const origFetch = window.fetch;
    let timer = null;
    const refresh = () => {
      clearTimeout(timer);
      timer = setTimeout(async () => {
        try {
          const html = await (await origFetch('/cart?section_id=main-cart-footer', { credentials: 'same-origin' })).text();
          const novo = new DOMParser().parseFromString(html, 'text/html').querySelector('brindes-black');
          const atual = document.querySelector('brindes-black');
          if (novo && atual) atual.replaceWith(novo);
        } catch (e) { console.warn('[brindes-black] refresh', e); }
      }, 400);
    };
    window.fetch = function (input, init) {
      const p = origFetch.apply(this, arguments);
      try {
        const url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/(change|update|add)(\.js)?(\?|$)/.test(url) && !window.__bbSyncing) p.then(refresh, () => {});
      } catch (e) {}
      return p;
    };
  }
})();
